import utils from "../common/util";

const cmpLoginRegisterForgotForms = {
	component: null,

	init: function (element)
	{
		utils.log('cmpLoginRegisterForgotForms initiated : #' + element.id, 'info');

		const _ = utils.setEnvironment(this);
		_.component = element;
		_.loginForm = document.getElementById('login-form');
		_.registerForm = document.getElementById('register-form');
		_.forgotPasswordForm = document.getElementById('forgot-password-form');
		_.formTriggers = element.querySelectorAll('.form-swap-trigger');

		_.onClickEvent(_.formTriggers);
	},

	onClickEvent: function (triggers)
	{
		for (let element of triggers) {
			element.addEventListener('click', (e) =>
			{
				let parentForm = (e.target).closest('form');
				let targetForm = document.getElementById((e.target).getAttribute('data-form'));

				utils.oneTimeListener(parentForm, 'transitionend', (e) =>
				{

					if (['opacity'].indexOf(e.propertyName) === -1) return;

					utils.showHideElement(parentForm, 'hide');

					utils.animateAndShow(targetForm, 'opacity-0');
				});

				if (targetForm) {
					parentForm.classList.add('opacity-0');
				}
			});
		}
	}
}

export default cmpLoginRegisterForgotForms;
